
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { ButtonLink } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Button Link`}</h1>
<p>{`Basically the same component as `}<a parentName="p" {...{
        "href": "/component-kit/components/button"
      }}><inlineCode parentName="a">{`Button`}</inlineCode></a>{` but the base element is a `}<inlineCode parentName="p">{`span`}</inlineCode>{` rather than a `}<inlineCode parentName="p">{`button`}</inlineCode>{`. This is done so that we can style a link as a button, since `}<inlineCode parentName="p">{`button`}</inlineCode>{` is not a valid child of `}<inlineCode parentName="p">{`a`}</inlineCode>{`. An equivalent example would be the `}<a parentName="p" {...{
        "href": "/component-kit/components/text-link"
      }}><inlineCode parentName="a">{`TextLink`}</inlineCode></a>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ButtonLink } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ButtonLink>Button Link</ButtonLink>`} component={ButtonLink} mdxType="Playground">
  <ButtonLink mdxType="ButtonLink">Button Link</ButtonLink>
</Playground>
<p>{`An example usage would be the following:`}</p>
<Playground __position={1} __code={`<a href="#">
  <ButtonLink>To nowhere</ButtonLink>
</a>`} mdxType="Playground">
  <a href="#">
    <ButtonLink mdxType="ButtonLink">To nowhere</ButtonLink>
  </a>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;